const updateAppVersion = (appVersion) => {
  let currentAppVersion = localStorage.getItem("FP-App-Version");

  if (currentAppVersion && appVersion && currentAppVersion !== appVersion) {
    localStorage.setItem("Fp-App-Version", appVersion);

    // openFpToast(
    //   "You are currently using an outdated version of the app. Refreshing the page...",
    //   "info"
    // );

    // setTimeout(() => {
    //   window.location.reload();
    // }, 3000);
  }

  // Update the app version in local storage
  localStorage.setItem("Fp-App-Version", appVersion);
};

export default updateAppVersion;
